export default "__VITE_ASSET__CHwL9Dis__"